// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import { IBodyUpdate, IQueryParamBase } from '~/utils/interface/common';
import {
  CREATE_QUARANTINE,
  CREATE_REPAIRED_QUARANTINE,
  DELETE_QUARANTINE,
  GET_DETAIL_QUARANTINE,
  GET_LIST_QUARANTINE,
  UPDATE_QUARANTINE,
} from '~/utils/constants/actionType';
import quarantineApi from '~/apis/quarantine';
import { IBodyRepairedQuarantine } from '~/utils/interface/quarantine';

export const getListQuarantine = createAsyncThunk(
  GET_LIST_QUARANTINE,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await quarantineApi.getListQuarantine(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createRepairedQuarantine = createAsyncThunk(
  CREATE_REPAIRED_QUARANTINE,
  async (body: IBodyRepairedQuarantine, { rejectWithValue }) => {
    try {
      const resp = await quarantineApi.createRepairedQuarantine(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteQuarantine = createAsyncThunk(
  DELETE_QUARANTINE,
  async (quarantineId: string, { rejectWithValue }) => {
    try {
      const resp = await quarantineApi.deleteQuarantine(quarantineId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createQuarantine = createAsyncThunk(CREATE_QUARANTINE, async (formData: FormData, { rejectWithValue }) => {
  try {
    const resp = await quarantineApi.createQuarantine(formData);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getDetailQuarantine = createAsyncThunk(
  GET_DETAIL_QUARANTINE,
  async (quarantineId: string, { rejectWithValue }) => {
    try {
      const resp = await quarantineApi.getDetailQuarantine(quarantineId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateQuarantine = createAsyncThunk(
  UPDATE_QUARANTINE,
  async (params: IBodyUpdate<FormData>, { rejectWithValue }) => {
    try {
      const resp = await quarantineApi.updateQuarantine(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
